import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { BrowserRouter, Routes, Route} from 'react-router-dom';


import { PendingOrder } from "./views/orders/PendingOrder";
import { DeliveredOrder } from "./views/orders/DeliveredOrder";
import { CanceledOrder } from "./views/orders/CanceledOrder";
import { Order } from "./views/orders/Order";
import { Statistic } from "./views/orders/Statistic";
import { ProductStatistic } from "./views/products/ProductStatistic";
import { Product } from "./views/products/Product";
import { User } from "./views/users/User";
import { Message } from "./views/genrality/Message";
import { Newsletter } from "./views/genrality/Newsletter";
import { Maintenance } from "./views/maintenances/Maintenance";
import { AccountStatistic } from "./views/accountbility/AccountStatistic";
import { Expenses } from "./views/accountbility/Expenses";
import { Debt } from "./views/accountbility/Debt";
import { Login } from "./views/auth/Login";
import { NotFoundPage } from "./views/NotFoundPage";
import ProtectedRoute from "./app/route/ProtectedRoute";


function App() 
{
  return (


     <BrowserRouter>
        <Routes>
        
          <Route path="/" element={ <Login /> }> </Route>

          {/* Toutes les routes protégées */}
          <Route element={<ProtectedRoute />}>

              <Route exact path="/commandes-en-cours" element={ <PendingOrder /> }> </Route>

              <Route path="/commandes-livrees" element={ <DeliveredOrder /> }> </Route>

              <Route path="/commandes-annulees" element={ <CanceledOrder /> }> </Route>

              <Route path="/statistiques-commandes" element={ <Statistic /> }> </Route>

              <Route path="/commande/:id" element={ <Order /> }> </Route>



              <Route path="/produit" element={ <Product /> }> </Route>

              <Route path="/statistiques-produits" element={ <ProductStatistic /> }> </Route>



              <Route path="/utilisateurs" element={ <User /> }> </Route>



              <Route path="/generalite" element={ <Message /> }> </Route>

              <Route path="/newsletters" element={ <Newsletter /> }> </Route>



              <Route path="/maintenance" element={ <Maintenance /> }> </Route>



              <Route path="/comptabilite" element={ <AccountStatistic /> }> </Route>

              <Route path="/depense" element={ <Expenses /> }> </Route>

              <Route path="/creance" element={ <Debt /> }> </Route>

          </Route>
        
        
  
          <Route path="*" element={ <NotFoundPage />  } ></Route> 
    
        </Routes>
      </BrowserRouter>

  );
}

export default App;
